const ZDANIA41 = [
  {
    name: "[6 klasa] Ang Luty 2024 - słówka",
    lang: 'en',
    zdania: [
      { pl: "samolubny", de: "selfish" },
      { pl: "złego usposobienia", de: "bad-tempered" },
      { pl: "twardy", de: "tough" },
      { pl: "przebiegły", de: "crafty" },
      { pl: "wrażliwy", de: "sensitive" },
      { pl: "rozsądny", de: "sensible" },
      { pl: "surowy", de: "strict" },
      { pl: "godny zaufania", de: "trustworthy" },
      { pl: "niezawodny, godny zaufania", de: "reliable" },
      { pl: "uzdolniony", de: "gifted" },
      { pl: "odważny", de: "brave" },
      { pl: "nudny", de: "dull" },
      { pl: "nieśmiały", de: "shy" },
      { pl: "niezawodny", de: "reliable" },
      { pl: "uparty", de: "stubborn" },
      { pl: "głupi", de: "silly" },
      { pl: "wesoły", de: "cheerful" },
      { pl: "współczujący", de: "sympathetic" },
      { pl: "niezdarny", de: "clumsy" },
      { pl: "lojalny", de: "loyal" },
      { pl: "delikatny", de: "gentle" },
      { pl: "uparty", de: "stubborn" }, // "bad-headed" nie jest standardowym określeniem, założyłem ponownie "stubborn"
      { pl: "apodyktyczny", de: "bossy" },
      { pl: "pewny siebie", de: "confident" },
      { pl: "nieuczciwy", de: "dishonest" },
      { pl: "hojny", de: "generous" },
      { pl: "pomocny", de: "helpful" },
      { pl: "niecierpliwy", de: "impatient" },
      { pl: "zazdrosny", de: "jealous" },
      { pl: "leniwy", de: "lazy" },
      { pl: "skromny", de: "modest" },
      { pl: "kapryśny", de: "moody" },
      { pl: "cierpliwy", de: "patient" },
      { pl: "uprzejmy", de: "polite" },
      { pl: "niegrzeczny", de: "rude" },
      { pl: "porządny", de: "tidy" },
      { pl: "nieprzyjazny", de: "unfriendly" },
      { pl: "nieporządny", de: "untidy" },
      { pl: "zdolny", de: "able" },
      { pl: "roztargniony", de: "absent-minded" },
      { pl: "żądny przygód", de: "adventurous" },
      { pl: "asertywny", de: "assertive" },
      { pl: "inteligentny", de: "brainy" },
      { pl: "ostrożny", de: "cautious" },
      { pl: "ostrony, ale inaczej niz cautious", de: "careful" },
      { pl: "arogancki", de: "arrogant" },
      { pl: "zarozumiały", de: "conceited" },
      { pl: "śmiały", de: "daring" },
      { pl: "oszukańczy, nieuczciwy - inaczej dishonest", de: "deceitful" },
      { pl: "lekceważący, brak szacunku", de: "disrespectful" },
      { pl: "pełen wątpliwości", de: "doubtful" },
      { pl: "niezdecydowany", de: "undecided" },
      { pl: "entuzjastyczny", de: "enthusiastic" },
      { pl: "chętny", de: "eager" },
      { pl: "wybredny", de: "fussy" },
      { pl: "niewiedzący", de: "ignorant" },
      { pl: "głośno mówiący", de: "loud-mouthed" },
      { pl: "dojrzały", de: "mature" },
      { pl: "psotny", de: "mischievous" },
      { pl: "wstrętny", de: "obnoxious" },
      { pl: "bezpośredni", de: "outspoken" },
      { pl: "porywczy", de: "quick-tempered" },
      { pl: "racjonalny", de: "rational" },
      { pl: "rozsądny", de: "reasonable" },
      { pl: "niezaspokojony", de: "restless" },
      { pl: "skąpy", de: "stingy" },
      { pl: "wsparcie", de: "supportive" },
      { pl: "troskliwy", de: "thoughtful" },
      { pl: "skrupulatny", de: "meticulous" },
      { pl: "niepoinformowany", de: "uninformed" },
      { pl: "nikczemny, podły", de: "despicable" },

      { pl: "dorosły", de: "adult" },

      {
        pl: "znaczy, oznacza (w kontekście 'to mean something') lub skąpy, złośliwy (w kontekście charakteru)",
        de: "mean",
      },
      {
        pl: "bystry, inteligentny (w kontekście umysłowym) lub zręczny, sprytny (w kontekście praktycznym)",
        de: "clever",
      },
      {
        pl: "miły, sympatyczny (w kontekście zachowania) lub przyjemny, ładny (w kontekście wyglądu)",
        de: "nice",
      },
      {
        pl: "tolerancyjny, łatwy w obsłudze (w kontekście charakteru) lub bezproblemowy, niewymagający (w kontekście sytuacji)",
        de: "easy-going",
      },
      {
        pl: "przyjacielski, życzliwy (w kontekście zachowania) lub przyjazny, nie wrogi (w kontekście relacji)",
        de: "friendly",
      },
      {
        pl: "cichy, spokojny (w kontekście zachowania) lub cichy, niehałaśliwy (w kontekście otoczenia)",
        de: "quiet",
      },
      {
        pl: "poważny (w kontekście zachowania) lub poważny, ważny (w kontekście sytuacji)",
        de: "serious",
      },
      {
        pl: "towarzyski, otwarty na kontakty z ludźmi (w kontekście zachowania) lub społeczny, lubiący przebywać w grupie (w kontekście preferencji)",
        de: "sociable",
      },
      {
        pl: "rozmowny, gadatliwy (w kontekście zachowania) lub komunikatywny, łatwo nawiązujący rozmowy (w kontekście umiejętności interpersonalnych)",
        de: "talkative",
      },
    ],
  },
];

const ZDANIA42 = [
  {
    name: "[6 klasa] Ang Luty 2024 - zdania",
    lang: 'en',
    zdania: [
      { pl: "On jest bardzo samolubny.", de: "He is very selfish." },
      {
        pl: "Ona jest często złego usposobienia rano.",
        de: "She is often bad-tempered in the morning.",
      },
      { pl: "Ta praca jest trudna.", de: "This job is tough." },
      { pl: "Lis jest przebiegły.", de: "The fox is crafty." },
      { pl: "Mój przyjaciel jest wrażliwy.", de: "My friend is sensitive." },
      {
        pl: "Noszenie płaszcza zimą jest rozsądne.",
        de: "Wearing a coat in winter is sensible.",
      },
      { pl: "Nasz nauczyciel jest surowy.", de: "Our teacher is strict." },
      {
        pl: "Możesz jej zaufać, jest godna zaufania.",
        de: "You can trust her, she's trustworthy.",
      },
      { pl: "On jest zawsze niezawodny.", de: "He is always reliable." },
      {
        pl: "Mój brat jest bardzo uzdolniony w muzyce.",
        de: "My brother is very gifted in music.",
      },
      {
        pl: "Być odważnym nie znaczy nie bać się.",
        de: "Being brave doesn't mean you're not scared.",
      },
      { pl: "Ta książka jest nudna.", de: "This book is dull." },
      { pl: "Byłem zbyt nieśmiały, by mówić.", de: "I was too shy to speak." },
      { pl: "On jest uparty.", de: "He is stubborn." },
      { pl: "To był głupi błąd.", de: "That was a silly mistake." },
      { pl: "Ona jest zawsze wesoła.", de: "She is always cheerful." },
      {
        pl: "On był współczujący, gdy byłem chory.",
        de: "He was sympathetic when I was sick.",
      },
      { pl: "Jestem tak niezdarny.", de: "I am so clumsy." },
      {
        pl: "Lojalny przyjaciel to skarb.",
        de: "A loyal friend is a treasure.",
      },
      {
        pl: "Ona mówi delikatnym głosem.",
        de: "She speaks in a gentle voice.",
      },
      { pl: "Szef był zbyt apodyktyczny.", de: "The boss was too bossy." },
      {
        pl: "On jest pewny swojej decyzji.",
        de: "He is confident about his decision.",
      },
      { pl: "Kłamstwo jest nieuczciwe.", de: "Lying is dishonest." },
      { pl: "Ona jest hojna.", de: "She is generous." },
      { pl: "Czy możesz mi pomóc?", de: "Can you help me?" },
      {
        pl: "Ona szybko się denerwuje w korkach.",
        de: "She gets impatient quickly in traffic.",
      },
      {
        pl: "On czuje zazdrość o jej sukces.",
        de: "He feels jealous of her success.",
      },
      { pl: "Nie bądź leniwy!", de: "Don't be lazy!" },
      {
        pl: "On jest skromny co do swoich osiągnięć.",
        de: "He is modest about his achievements.",
      },
    ],
  },
];

const ZDANIA43 = [
  {
    name: "[6 klasa] Niemiecki luty 2024",
    lang: 'de',
    zdania: [
      {
        pl: "Stefanie, jak tu wygląda?!",
        de: "Stefan, wie sieht es hier denn aus?!",
      },
      {
        pl: "Niemożliwe!",
        de: "Unmöglich!",
      },
      {
        pl: "Proszę, posprzątaj, i to natychmiast!",
        de: "Mach bitte Ordnung, und zwar sofort!",
      },
      {
        pl: "Już dobrze, Mamo!",
        de: "Schon gut, Mutti!",
      },
      {
        pl: "Książki postawię na półce",
        de: "Die Bücher stelle ich auf das Regal",
      },
      {
        pl: "Moje ciuchy położę w szafie",
        de: "Meine Klamotten lege ich in den Schrank",
      },
      {
        pl: "Buty do tenisa postawię pod łóżkiem",
        de: "Die Tennisschuhe stelle ich unter das Bett",
      },
      {
        pl: "CD położę na półce",
        de: "Die CDs lege ich auf das Regal",
      },
      {
        pl: "A puszki?",
        de: "Und die Dosen?",
      },
      {
        pl: "Trafią do kosza na śmieci w kuchni. Nie martw się!",
        de: "Die kommen in den Abfalleimer in der Küche. Keine Sorge!",
      },
      {
        pl: "Więc Mamo, co teraz powiesz?",
        de: "Also Mutti, was sagst du jetzt?",
      },
      {
        pl: "Książki stoją na półce",
        de: "Die Bücher stehen auf dem Regal",
      },
      {
        pl: "Ciuchy leżą w szafie",
        de: "Die Klamotten liegen im Schrank",
      },
      {
        pl: "Buty do tenisa stoją pod łóżkiem",
        de: "Die Tennisschuhe stehen unter dem Bett",
      },
      {
        pl: "CD leżą na półce",
        de: "Die CDs liegen auf dem Regal",
      },
      {
        pl: "A puszki?",
        de: "Und die Dosen?",
      },
      {
        pl: "Są w koszu na śmieci w kuchni",
        de: "Die sind in dem Abfalleimer in der Küche",
      },
      {
        pl: "stać/postawić",
        de: "stehen/stellen",
      },
      {
        pl: "leżeć/położyć",
        de: "liegen/legen",
      },
      {
        pl: "być",
        de: "sein",
      },
      {
        pl: "przychodzić",
        de: "kommen",
      },
      {
        pl: "wieszać/powiesić",
        de: "hängen/hängen",
      },
      {
        pl: "Stefan stawia książki na półce",
        de: "Stefan stellt die Bücher auf das Regal",
      },
      {
        pl: "Słuchawki postaw na biurku",
        de: "Stelle den Kopfhörer auf den Schreibtisch",
      },
      {
        pl: "Torba szkolna postaw obok łóżka",
        de: "Stelle die Schultasche neben das Bett",
      },
      {
        pl: "Książka do niemieckiego postaw na półce",
        de: "Stelle das Deutschbuch auf das Regal",
      },
      {
        pl: "Puszkę postaw za telewizorem",
        de: "Stelle die Dose hinter den Fernseher",
      },
      {
        pl: "CD połóż do szuflady",
        de: "Lege die CDs in die Schublade",
      },
      {
        pl: "Buty połóż pod łóżko",
        de: "Lege die Schuhe unter das Bett",
      },
      {
        pl: "Sweter połóż do szafy",
        de: "Lege den Pullover in den Schrank",
      },
      {
        pl: "Smartfon połóż na stoliku nocnym",
        de: "Lege das Smartphone auf den Nachttisch",
      },
      {
        pl: "Gdzie mam położyć CD?",
        de: "Wohin soll ich die CDs legen?",
      },
      {
        pl: "Połóż CD na półce!",
        de: "Leg die CDs auf das Regal!",
      },
      {
        pl: "Gdzie mam postawić buty?",
        de: "Wohin soll ich die Schuhe stellen?",
      },
      {
        pl: "Postaw buty pod łóżko!",
        de: "Stell die Schuhe unter das Bett!",
      },
      {
        pl: "Gdzie mam położyć sweter?",
        de: "Wohin soll ich den Pullover legen?",
      },
      {
        pl: "Połóż sweter do szafy!",
        de: "Leg den Pullover in den Schrank!",
      },
      {
        pl: "Gdzie mam postawić torbę szkolną?",
        de: "Wohin soll ich die Schultasche stellen?",
      },
      {
        pl: "Postaw torbę szkolną obok biurka!",
        de: "Stell die Schultasche neben den Schreibtisch!",
      },
      {
        pl: "Gdzie mam położyć słuchawki?",
        de: "Wohin soll ich die Kopfhörer legen?",
      },
      {
        pl: "Połóż słuchawki na stoliku nocnym!",
        de: "Leg die Kopfhörer auf den Nachttisch!",
      },
      {
        pl: "Gdzie mam postawić puszkę?",
        de: "Wohin soll ich die Dose stellen?",
      },
      {
        pl: "Postaw puszkę do komody!",
        de: "Stell die Dose in die Kommode!",
      },
      {
        pl: "Gdzie mam położyć książkę do niemieckiego?",
        de: "Wohin soll ich das Deutschbuch legen?",
      },
      {
        pl: "Połóż książkę do niemieckiego na półce!",
        de: "Leg das Deutschbuch auf das Regal!",
      },
      {
        pl: "Gdzie mam położyć smartfon?",
        de: "Wohin soll ich das Smartphone legen?",
      },
      {
        pl: "Połóż smartfon na biurku!",
        de: "Leg das Smartphone auf den Schreibtisch!",
      },
      {
        pl: "pralka",
        de: "die Waschmaschine",
      },
      {
        pl: "regał na książki",
        de: "das Bücherregal",
      },
      {
        pl: "szafa na ubrania",
        de: "der Kleiderschrank",
      },
      {
        pl: "stół jadalny",
        de: "der Esstisch",
      },
      {
        pl: "kuchenka elektryczna",
        de: "der Elektroherd",
      },
      {
        pl: "telewizor",
        de: "der Fernseher",
      },
      {
        pl: "lodówka",
        de: "der Kühlschrank",
      },
      {
        pl: "sofa",
        de: "das Sofa",
      },
      {
        pl: "łóżko",
        de: "das Bett",
      },
      {
        pl: "krzesła",
        de: "die Stühle",
      },
      {
        pl: "dywan",
        de: "der Teppich",
      },
      {
        pl: "lustro",
        de: "der Spiegel",
      },
      {
        pl: "fotel",
        de: "der Sessel",
      },
      {
        pl: "sypialnia",
        de: "das Schlafzimmer",
      },
      {
        pl: "gabinet",
        de: "das Arbeitszimmer",
      },
      {
        pl: "salon",
        de: "das Wohnzimmer",
      },
      {
        pl: "kuchnia",
        de: "die Küche",
      },
      {
        pl: "łazienka",
        de: "das Bad",
      },
      {
        pl: "biurko",
        de: "der Schreibtisch",
      },
      {
        pl: "przed",
        de: "vor",
      },
      {
        pl: "na",
        de: "Auf",
      },
      {
        pl: "za",
        de: "hinter",
      },
      {
        pl: "pod",
        de: "unter",
      },
      {
        pl: "w",
        de: "In ",
      },
      {
        pl: "nad",
        de: "über",
      },
      {
        pl: "przy",
        de: "An",
      },
      {
        pl: "między",
        de: "zwischen",
      },
      {
        pl: "Leży na biurku.",
        de: "Sie liegt auf dem Schreibtisch.",
      },
      {
        pl: "Leżą w szafie.",
        de: "Sie liegen in dem Schrank.",
      },
      {
        pl: "Stoi pod łóżkiem",
        de: "Es steht unter dem Bett",
      },
      {
        pl: "Stoją przed szufladą",
        de: "Sie stehen vor der Schublade",
      },
      {
        pl: "Leży na półce",
        de: "Es liegt auf dem Regal",
      },
      {
        pl: "Są za komodą",
        de: "Sie sind hinter der Kommode",
      },
      {
        pl: "Stoi obok stolika nocnego",
        de: "Es steht neben dem Nachttisch",
      },
      {
        pl: "Stoją obok krzesła",
        de: "Sie stehen neben dem Stuhl",
      },
      {
        pl: "okno",
        de: "das Fenster",
      },
      {
        pl: "drzwi",
        de: "die Tür",
      },
      {
        pl: "w salonie",
        de: "im Wohnzimmer",
      },
      {
        pl: "w torbie szkolnej",
        de: "in der Schultasche",
      },
      {
        pl: "obok komputera",
        de: "neben dem Computer",
      },
      {
        pl: "pod stołem",
        de: "unter dem Tisch",
      },
      {
        pl: "pod szafą",
        de: "unter dem Schrank",
      },
      {
        pl: "pod łóżkiem",
        de: "unter dem Bett",
      },
      {
        pl: "w kuchni",
        de: "in der Küche.",
      },
      {
        pl: "obok telewizora",
        de: "neben dem Fernseher.",
      },
      {
        pl: "na biurku",
        de: "auf dem Schreibtisch.",
      },
      {
        pl: "Gdzie mam postawić łóżko?",
        de: "Wohin soll ich das Bett stellen?",
      },
      {
        pl: "Postaw je po prawej stronie ściany.",
        de: "Stell es rechts an die Wand.",
      },
      {
        pl: "Gdzie mam postawić biurko?",
        de: "Wohin soll ich den Schreibtisch stellen?",
      },
      {
        pl: "Postaw je przy oknie.",
        de: "Stell ihn an das Fenster.",
      },
      {
        pl: "Gdzie postawić szafę?",
        de: "Wohin kommt der Schrank?",
      },
      {
        pl: "Postaw ją po lewej stronie ściany.",
        de: "Stell ihn links an die Wand.",
      },
      {
        pl: "A regał na książki?",
        de: "Und das Bücherregal?",
      },
      {
        pl: "Postaw go po prawej stronie, obok biurka.",
        de: "Stell es rechts in die Ecke, neben den Schreibtisch.",
      },
      {
        pl: "Myślisz, że powinienem położyć dywan pod biurko?",
        de: "Meinst du, ich soll den Teppich unter den Schreibtisch legen?",
      },
      {
        pl: "Nie, najlepiej połóż dywan na środku pokoju.",
        de: "Nein, am besten legst du den Teppich in die Mitte des Zimmers.",
      },
      {
        pl: "A nowe plakaty? Gdzie mam je powiesić?",
        de: "Und die neuen Poster? Wohin soll ich sie hängen?",
      },
      {
        pl: "Powieś je na ścianie, nad łóżkiem.",
        de: "Häng sie an die Wand, über das Bett.",
      },
    ],
  },
];

const ZDANIA44 = [
  {
    name: "[6 klasa] Niem Marzec 2024 - słówka",
    lang: 'de',
    zdania: [
      {
        pl: "Uważam pracę kucharza za dobrze płatną.",
        de: "Ich finde die Arbeit eines Kochs gut bezahlt.",
      },
      {
        pl: "Uważam pracę sprzedawczyni za słabo płatną.",
        de: "Ich finde die Arbeit einer Verkäuferin schlecht bezahlt.",
      },
      {
        pl: "Uważam pracę piłkarza za zabawną.",
        de: "Ich finde die Arbeit eines Fußballspielers lustig.",
      },
      {
        pl: "Uważam pracę aktorki za kreatywną.",
        de: "Ich finde die Arbeit einer Schauspielerin kreativ.",
      },
      {
        pl: "Uważam pracę kierowcy autobusu za interesującą.",
        de: "Ich finde die Arbeit eines Busfahrers interessant.",
      },
      {
        pl: "Uważam pracę modelki/modela za dobrze płatną.",
        de: "Ich finde die Arbeit eines Models gut bezahlt.",
      },
      {
        pl: "Uważam pracę sprzedawczyni za kreatywną.",
        de: "Ich finde die Arbeit einer Verkäuferin kreativ.",
      },
      {
        pl: "Uważam pracę kucharza za interesującą.",
        de: "Ich finde die Arbeit eines Kochs interessant.",
      },
      {
        pl: "Uważam pracę piłkarza za słabo płatną.",
        de: "Ich finde die Arbeit eines Fußballspielers schlecht bezahlt.",
      },
      {
        pl: "Uważam pracę aktorki za zabawną.",
        de: "Ich finde die Arbeit einer Schauspielerin lustig.",
      },
      {
        pl: "Uważam pracę kierowcy autobusu za słabo płatną.",
        de: "Ich finde die Arbeit eines Busfahrers schlecht bezahlt.",
      },
      {
        pl: "Uważam pracę modelki/modela za interesującą.",
        de: "Ich finde die Arbeit eines Models interessant.",
      },
      {
        pl: "Uważam pracę sprzedawczyni za zabawną.",
        de: "Ich finde die Arbeit einer Verkäuferin lustig.",
      },
      {
        pl: "Uważam pracę kucharza za kreatywną.",
        de: "Ich finde die Arbeit eines Kochs kreativ.",
      },
      {
        pl: "Uważam pracę piłkarza za dobrze płatną.",
        de: "Ich finde die Arbeit eines Fußballspielers gut bezahlt.",
      },
      { pl: "nauczyciel", de: "Lehrer" },
      { pl: "mechanik samochodowy", de: "Automchaniker" },
      { pl: "programista", de: "Programmierer" },
      { pl: "kucharz", de: "Koch" },
      { pl: "fryzjer", de: "Frisör" },
      { pl: "lekarz", de: "Arzt" },
      { pl: "pielęgniarz", de: "Krankenpfleger" },
      { pl: "menedżer", de: "Manager" },
      { pl: "śpiewak", de: "Sänger" },
      { pl: "opiekun zwierząt", de: "Tierpfleger" },
      { pl: "sprzedawca", de: "Verkäufer" },
      { pl: "policjant", de: "Polizist" },
      { pl: "sportowiec", de: "Sportler" },
      { pl: "model/modelka", de: "Model" },
      { pl: "nauczycielka", de: "Lehrerin" },
      { pl: "mechaniczka samochodowa", de: "Automchanikerin" },
      { pl: "programistka", de: "Programmiererin" },
      { pl: "kucharka", de: "Köchin" },
      { pl: "fryzjerka", de: "Frisörin" },
      { pl: "lekarka", de: "Ärztin" },
      { pl: "pielęgniarka", de: "Krankenpflegerin" },
      { pl: "menedżerka", de: "Managerin" },
      { pl: "śpiewaczka", de: "Sängerin" },
      { pl: "opiekunka zwierząt", de: "Tierpflegerin" },
      { pl: "sprzedawczyni", de: "Verkäuferin" },
      { pl: "policjantka", de: "Polizistin" },
      { pl: "sportowczyni", de: "Sportlerin" },
      { pl: "model/modelka", de: "Model" },
    ],
  },
];

export { ZDANIA41, ZDANIA42, ZDANIA43, ZDANIA44 };
